import api from './../api/api';
import BaseService from "@/module_dashboard/api/base";
const baseUrl = process.env.VUE_APP_API_URL;

async function getCountryCode() {
    try {
        const response = await fetch('https://ipapi.co/json');
        if (!response.ok) {
            return 'SGP';
        }
        const data = await response.json();
        return data.country_code_iso3 || 'SGP'
    } catch (error) {
        return 'SGP';
    }
}

export default {
    async authAccessCode(data) {
        let response = await api.put(baseUrl + '/corporate-user/register-code', data);
        return response.data;
    },
    async verifyUser(data) {
        let response = await api.put(baseUrl + '/corporate-user/verify', data);
        return response.data;
    },
    async getCorporateTheme(data) {
        let response = await api.get(baseUrl + `/corporate/get-theme?name=${data.name}`);
        return response.data;
    },
    async getCorporateProgram(data) {
        let response = await api.get(baseUrl + `/corporate-program/get-programs?id=${data.id}`);
        return response.data;
    },
    async getTenantProgram(data) {
        let response = await api.get(baseUrl + `/corporate-program/get-tenant-programs?id=${data.id}`);
        return response.data;
    },
    async getCorporateDashboard(data) {
        let response = await api.post(baseUrl + '/corporate/dashboard', data);
        return response.data;
    },
    async getWorkoutReward(data) {
        let response = await api.get(baseUrl + `/rewards/get-workout-reward?session=${data.session}`);
        return response.data;
    },
    async verifyPromoCode(data) {
        let response = await api.get(baseUrl + `/promo-code/validate/${data.promocode}`);
        return response.data;
    },
    async authAccessCodeForCorporateSignup(data) {
        let response = await api.put(baseUrl + '/corporate-user/register-as-corporate', data);
        return response.data;
    },
    async getSubscriptions() {
        let response = await api.get(baseUrl + `/subscription`);
        return response.data;
    },
    async createCheckoutSession(data) {
        let response = await api.post(baseUrl + `/payments/create-checkout-session`, data);
        return response.data;
    },
    async createNonCorporateCheckoutSession() {
        let response = await api.get(baseUrl + `/payments/non-corporate-user-buy-plan-session`);
        return response.data;
    },
    async getTransactionDetails(tnxID) {
        let response = await api.get(baseUrl + `/payments/transaction/${tnxID}`);
        return response.data;
    },
    async updateCorporate(data) {
        let response = await api.put(baseUrl + '/corporate/update', data);
        return(response);
    },
    async endUserSubscriptionPlans(program='Fitness Program') {
        const country = await getCountryCode();
        let response = await api.get(baseUrl + `/payments/end-user/subscription-plans?program=${program}&country=${country}`);
        return response.data;
    },
    async createEndUserCheckoutSession(body) {
        let response = await api.post(baseUrl + '/payments/end-user/create-checkout-session', body);
        return response.data;
    },
    async getEndUserTransactionHistory(params) {
        const url = baseUrl + `/payments/end-user/transactions?${BaseService.getQueryString(params)}`
        let response = await api.get(url);
        return response.data;
    },
    async corporateSubscriptionPlans() {
        const country = await getCountryCode();
        let response = await api.get(baseUrl + `/payments/admin/subscriptions?country=${country}`);
        return response.data;
    },
    async createAdminCheckoutSession(body) {
        let response = await api.post(baseUrl + '/payments/admin/create-checkout-session', body);
        return response.data;
    },
    async getCorporateTransactionHistory(params) {
        const url = baseUrl + `/payments/admin/transactions?${BaseService.getQueryString(params)}`
        let response = await api.get(url);
        return response.data;
    }
}
